
  <template>
  <h1>Illust</h1>
  <p>準備中...</p>
  <a
    href="
https://instagram.com/yzuesm_/"
    >Instagram</a
  >：ここにイラストを載せています
</template>

